import qs from 'qs'
import request from '../utils/request'

/**---------------------------------公用接口---------------------------------------*/
//获取菜单接口
//查询物料中心列表
export function getUserMenu({account}) {
  return request({
    method: 'GET',
    url: `/external-common/users/${account}/apps/materialCenter/menu?resourceCode=materialCenter`
  })
}
//获取用户操作权限
export function getUserAction({account, code}) {
  return request({
    method: 'GET',
    url: `/external-common/users/${account}/apps/PriceControl/action?resourceCode=${code}`
  })
}
/**---------------------------------物料中心---------------------------------------*/
// 数据初始化
export function getDataInit() {
  return request({
    url: `/mm/material/getDataInit`,
  })
}
/**---------------------------------物料新增---------------------------------------*/
// 搜索物料
export function matchMaterial({ ...params }) {
  return request({
    method: 'POST',
    url: `/mm/material/matchMaterial`,
    data: params
  })
}
// 新增
export function saveMaterial({ ...params }) {
  return request({
    method: 'POST',
    url: `/mm/material/saveMaterial`,
    data: params
  })
}
//修改
export function updateMaterial({ ...params }) {
  return request({
    method: 'POST',
    url: `/mm/material/updateMaterial`,
    data: params
  })
}
//查询获取物料唯一属性
export function getAttribute({ ...params }) {
  return request({
    method: 'POST',
    url: `/mm/material/getAttribute`,
    data: params
  })
}
/**---------------------------------物料查询---------------------------------------*/
//查询
export function queryMaterial({ ...params }) {
  return request({
    method: 'POST',
    url: `/mm/material/queryMaterial`,
    data: params
  })
}
//查询详情
export function detailMaterial({ ...params }) {
  return request({
    method: 'POST',
    url: `/mm/material/detailMaterial`,
    data: params
  })
}
//启用物料
export function activeMaterial({ ...params }) {
  return request({
    method: 'POST',
    url: `/mm/material/activeMaterial`,
    data: params
  })
}
//物料唯一性校验及推送配置
export function validity({ ...params }) {
  return request({
    method: 'POST',
    url: `/mm/material/validity`,
    data: params
  })
}
//物料唯一性校验及推送配置
export function deleteMaterial({ ...params }) {
  return request({
    method: 'POST',
    url: `/mm/material/deleteMaterial`,
    data: params
  })
}

//销售-渠道-历史销量趋势查询
export function getChannel({ ...params }) {
	return request({
	  method: 'POST',
	  url: `/bpc/income/channel/query`,
	  data: params
	})
}
// 销售-渠道-收入填报查询
export function getChannelCome({ ...params }) {
	return request({
	  method: 'GET',
	  url: `/bpc/income/queryChannelIncome`,
	  data: params
	})
}
